export default __webpack_public_path__ + "static/ux-research-18046526bb4e6c836ee340429503fde6.png";